import React from 'react';
import LoadingSkeleton from './LoadingSkeleton';

const LoadingCoupon: React.FC = () => {
  return (
    <div className="flex flex-col gap-2 generate-coupon-card loading">
      <div className="flex gap-2">

        {/* LEFT SIDE — Coupon Details */}
        <div className="coupon-details coupon-details-readonly flex flex-col gap-2">

          <LoadingSkeleton width="120px" height="20px" /> {/* Kupong label */}
          <LoadingSkeleton width="100%" height="38px" />

          <LoadingSkeleton width="120px" height="20px" />
          <LoadingSkeleton width="100%" height="38px" />

          <LoadingSkeleton width="120px" height="20px" />
          <LoadingSkeleton width="100%" height="38px" />
        </div>


        {/* RIGHT SIDE — Assessment */}
        <div style={{ flex: '1' }} className="coupon-assessment flex flex-col gap-2">

          {/* Header */}
          <div className="flex items-center justify-between">
            <LoadingSkeleton width="80px" height="26px" />
            <div className="flex gap-2">
              <LoadingSkeleton width="28px" height="28px" />
              <LoadingSkeleton width="28px" height="28px" />
              <LoadingSkeleton width="28px" height="28px" />
              <LoadingSkeleton width="140px" height="36px" />
            </div>
          </div>

          {/* Rating row */}
          <div className="flex items-center gap-2">
            <LoadingSkeleton width="120px" height="20px" />
          </div>

          {/* Motivation */}
          <LoadingSkeleton width="100%" height="38px" />

          {/* Assessment columns */}
          <div className="assessment-columns flex gap-2">

            <div style={{ flex: '1' }} className="flex flex-col gap-1 flex-1">
              <LoadingSkeleton width="120px" height="16px" />
              <LoadingSkeleton width="100%" height="80px" />
            </div>

            <div style={{ flex: '1' }} className="flex flex-col gap-1 flex-1">
              <LoadingSkeleton width="120px" height="16px" />
              <LoadingSkeleton width="100%" height="80px" />
            </div>

            <div style={{ flex: '1' }} className="flex flex-col gap-1 flex-1">
              <LoadingSkeleton width="120px" height="16px" />
              <LoadingSkeleton width="100%" height="80px" />
            </div>

          </div>

        </div>

      </div>
    </div>
  );
};

export default LoadingCoupon;
